/** Verde de la marca WhatsApp, para los botones de envío por WhatsApp. */
export const VERDE_WHATSAPP = '#25D366';
export const VERDE_WHATSAPP_HOVER = '#1DA851';

/** Estilo (makeStyles) de botón contained verde WhatsApp con texto blanco. */
export const botonWhatsapp = {
  backgroundColor: VERDE_WHATSAPP,
  color: '#fff',
  '&:hover': {
    backgroundColor: VERDE_WHATSAPP_HOVER,
    // En touch MUI deja el hover pegado: se vuelve al verde normal.
    '@media (hover: none)': { backgroundColor: VERDE_WHATSAPP }
  }
};
